<template>
  <paginate
    ref="paginate"
    :page-count="pageCount"
    :initial-page="currentPage"
    :force-page="currentPage"
    :click-handler="changePage"
    :page-range="1"
    :margin-pages="1"
    prev-text="Prev"
    next-text="Next"
    container-class="pagination"
    page-class="page-item"
    page-link-class="page-link"
    prev-class="page-item"
    prev-link-class="page-link"
    next-class="page-item"
    next-link-class="page-link"
  />
</template>

<script>
import Paginate from 'vuejs-paginate'
export default {
  name: 'dt-paginate',
  components: {
    Paginate
  },
  computed: {
    currentPage: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  props: {
    value: Number,
    pageCount: Number
  },
  methods: {
    changePage(pageNumber) {
      this.currentPage = pageNumber
      this.$emit('change', pageNumber)
    }
  },
  watch: {
    currentPage(value) {
      this.$refs.paginate.selected = value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utilities/paginate/dt-paginate.vue